import type { FC } from 'react';

type IconProps = {
    className?: string;
};

// 全画面表示アイコン
export const FullscreenEnterIcon: FC<IconProps> = ({ className }) => (
    <svg
        className={className}
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path d="M4 4h6v2H6v4H4V4zM14 4h6v6h-2V6h-4V4zM6 14v4h4v2H4v-6h2zM18 14h2v6h-6v-2h4v-4z" />
    </svg>
);

// 全画面表示解除アイコン
export const FullscreenExitIcon: FC<IconProps> = ({ className }) => (
    <svg
        className={className}
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path d="M10 4v2H6v4H4V4h6zm10 0v6h-2V6h-4V4h6zM4 14h2v4h4v2H4v-6zm14 0h2v6h-6v-2h4v-4z" />
    </svg>
);
